module.exports = __webpack_public_path__ + "images/plan-success-18797763b0fdabc673cdcd7042fb7a0a.png";